import _defineProperty from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import classnames from 'classnames';
import React, { useState, useCallback, useRef, useEffect } from 'react';
import { Icon } from '../../icon';
import styles from './form-input.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var FormInput = function FormInput(_ref) {
  var _classnames;

  var id = _ref.id,
      className = _ref.className,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'text' : _ref$type,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      _ref$attributes = _ref.attributes,
      attributes = _ref$attributes === void 0 ? {} : _ref$attributes,
      error = _ref.error,
      success = _ref.success,
      value = _ref.value,
      onFocus = _ref.onFocus,
      onBlur = _ref.onBlur,
      onChange = _ref.onChange,
      onClear = _ref.onClear,
      maxLength = _ref.maxLength,
      placeholder = _ref.placeholder,
      icon = _ref.icon,
      enableFocus = _ref.enableFocus,
      children = _ref.children;

  var _useState = useState(type),
      typeInput = _useState[0],
      setTypeInput = _useState[1];

  var inputRef = useRef(null);
  var onToggleTypePassword = useCallback(function () {
    if (typeInput === 'password') {
      setTypeInput('text');
    } else {
      setTypeInput('password');
    }
  }, [typeInput]);
  useEffect(function () {
    if (enableFocus) {
      var _inputRef$current;

      (_inputRef$current = inputRef.current) === null || _inputRef$current === void 0 ? void 0 : _inputRef$current.focus();
    }
  }, [enableFocus]);
  return /*#__PURE__*/_jsxs("div", {
    className: classnames(className, styles.container),
    children: [/*#__PURE__*/_jsxs("div", {
      className: styles.inputContent,
      children: [/*#__PURE__*/_jsx("input", _objectSpread(_objectSpread({}, attributes), {}, {
        id: id,
        type: typeInput,
        value: value,
        maxLength: maxLength,
        disabled: disabled,
        onFocus: onFocus,
        onBlur: onBlur,
        onChange: onChange,
        placeholder: placeholder,
        className: classnames(styles.input, (_classnames = {}, _defineProperty(_classnames, styles.error, error), _defineProperty(_classnames, styles.success, success), _defineProperty(_classnames, styles.hasIcon, icon), _classnames)),
        ref: inputRef
      })), icon ? /*#__PURE__*/_jsx("div", {
        className: styles.icon,
        children: icon
      }) : null, value && !disabled && onClear ? /*#__PURE__*/_jsx("button", {
        "aria-label": "Close",
        id: "".concat(id, "_clear"),
        type: "button",
        className: styles.button,
        onClick: onClear,
        children: /*#__PURE__*/_jsx(Icon, {
          name: "close",
          className: styles.iconClose
        })
      }) : null, value && !disabled && type === 'password' ? /*#__PURE__*/_jsx("button", {
        "aria-hidden": true,
        type: "button",
        className: styles.button,
        onClick: onToggleTypePassword,
        children: /*#__PURE__*/_jsx(Icon, {
          name: "eye",
          className: styles.iconEye
        })
      }) : null]
    }), children ? /*#__PURE__*/_jsx("div", {
      className: styles.content,
      children: children
    }) : null]
  });
};